import React from "react";
import { integrations, integrationsHeading } from "../mock";

const Bubble = ({ item }) => (
  <div className="flex h-36 w-28 shrink-0 items-center justify-center rounded-full bg-white shadow-[0_14px_34px_rgba(20,40,70,0.08)]">
    <img
      src={item.logo}
      alt={item.name}
      className="h-12 w-12 object-contain"
    />
  </div>
);

/* a vertically scrolling column (content duplicated for a seamless loop) */
const LogoColumn = ({ items, direction }) => (
  <div
    className={`flex flex-col gap-5 ${direction === "up" ? "v-up" : "v-down"}`}
  >
    {[...items, ...items].map((item, i) => (
      <Bubble key={`${item.name}-${i}`} item={item} />
    ))}
  </div>
);

const IntegrationsSection = () => {
  const colA = integrations.filter((_, i) => i % 2 === 0);
  const colB = integrations.filter((_, i) => i % 2 === 1);

  return (
    <section id="integrations" className="bg-[#EDF1F8] py-20">
      <div className="mx-auto max-w-[1180px] px-6">
        <div className="relative overflow-hidden rounded-[40px] border-2 border-dashed border-slate-300 bg-white/40 p-8 backdrop-blur-sm md:p-14">
          <div className="grid grid-cols-1 items-center gap-12 md:grid-cols-2">
            {/* left: text */}
            <div>
              <h2 className="font-serif text-[#16263F] leading-[1.02] tracking-tight">
                <span className="block text-[8vw] md:text-[3.4rem]">
                  {integrationsHeading.line1}
                </span>
                <span className="block text-[8vw] md:text-[3.4rem]">
                  {integrationsHeading.line2}
                </span>
              </h2>
              <p className="mt-8 max-w-md text-[16px] leading-7 text-slate-400">
                {integrationsHeading.description}
              </p>
            </div>

            {/* right: two vertical marquee columns */}
            <div
              className="relative mx-auto flex h-[460px] gap-5 overflow-hidden md:mr-0"
              style={{
                WebkitMaskImage:
                  "linear-gradient(to bottom, transparent 0%, black 14%, black 86%, transparent 100%)",
                maskImage:
                  "linear-gradient(to bottom, transparent 0%, black 14%, black 86%, transparent 100%)",
              }}
            >
              <LogoColumn items={colA} direction="up" />
              <LogoColumn items={colB} direction="down" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntegrationsSection;
